import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  private overflowClass = "overflow-hidden";

  static targets = ["dialog", "close"];

  static values = {
    autoShow: Boolean,
    dismissOnEscapePress: Boolean,
  };

  declare dialogTarget: HTMLDialogElement;
  declare closeTarget: HTMLButtonElement;
  declare autoShowValue: boolean;
  declare dismissOnEscapePressValue: boolean;

  connect() {
    if (!this.dialogTarget) return;
    if (this.autoShowValue) this.showModal();

    this.onClose = this.onClose.bind(this);
    this.dialogTarget.addEventListener("close", this.onClose);

    this.onBeforeCache = this.onBeforeCache.bind(this);
    document.addEventListener("turbolinks:before-cache", this.onBeforeCache);
  }

  disconnect() {
    if (!this.dialogTarget) return;

    this.dialogTarget.removeEventListener("close", this.onClose);
    document.removeEventListener("turbolinks:before-cache", this.onBeforeCache);
  }

  // Close the dialog before Turbolinks caches the page to avoid issues
  // with open dialogs when navigating back where the backdrop doesn't appear
  // and the dialog isn't in the top layer.
  onBeforeCache() {
    if (this.dialogTarget.open) {
      this.dialogTarget.close();
    }
  }

  onClose() {
    const closeSource = this.dialogTarget.returnValue;
    if (this.dismissOnEscapePressValue && closeSource !== "dismiss") {
      this.closeTarget.click();
    }

    this.enableScroll();
  }

  close() {
    this.dialogTarget.close("dismiss");
  }

  showModal() {
    if (!this.dialogTarget.open) {
      this.dialogTarget.showModal();
      this.disableScroll();
    }
  }

  enableScroll() {
    document.body.classList.remove(this.overflowClass);
    document.documentElement.classList.remove(this.overflowClass);
  }

  disableScroll() {
    document.body.classList.add(this.overflowClass);
    document.documentElement.classList.add(this.overflowClass);
  }
}
